import request from '../utils/request'
export const listLeaves = params => request.get('/leave-requests', { params })
export const createLeave = data => request.post('/leave-requests', data)
export const approveLeave = (id, auditRemark) => request.post(`/leave-requests/${id}/approve`, { auditRemark })
export const rejectLeave = (id, auditRemark) => request.post(`/leave-requests/${id}/reject`, { auditRemark })
export const cancelLeave = (id, auditRemark) => request.post(`/leave-requests/${id}/cancel`, { auditRemark })
